import { Filter, useToast } from 'vindi-ds-components';
import api from '@services/api';

function listProducts(params, showToast) {
  const { page, perPage } = params;
  return api
    .get('/admin/products', { page, per_page: perPage })
    .then((response) => ({
      products: response.data.products,
      totalCount: response.data.total_products,
    }))
    .catch(() => {
      showToast('Error no servidor', { severity: 'error' });
    });
}

function useFilter() {
  const showToast = useToast();
  const listing = Filter.useBrowserListing({
    queryOptions: {
      queryKey: 'list-products',
      queryFn: (params) => listProducts(params, showToast),
    },
    filterOptions: {
      pagination: {
        enabled: true,
        getCount: async (query) => query?.data?.totalCount || 0,
        perPage: 25,
      },
    },
  });

  return {
    listing,
  };
}

export default useFilter;
